/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

// We are using short links for tracking purpose (https://links.elastic.dev/)
export const getPricingLink = (
  product_type: 'stack_hosted' | 'elasticsearch' | 'security' | 'observability',
) => {
  if (product_type === 'stack_hosted') {
    return 'https://ela.st/cloud-pricing?source=billing-usage&productType=stack_hosted'
  }

  return `https://ela.st/serverless-pricing?source=billing-usage&project=${product_type}`
}
